import { render, staticRenderFns } from "./OpenSource.vue?vue&type=template&id=59280feb"
import script from "./OpenSource.vue?vue&type=script&lang=js"
export * from "./OpenSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports